// Imports
import { useState, Fragment } from 'react';
import { useSelector } from 'react-redux';

import CameraLogs from "../../../vidfleet/views/cameraLogs";
import DmsStatuses from "../../../vidfleet/views/dmsStatuses";
import PowerLost from "../../../vidfleet/views/powerLost";
import SdCardStatus from "../../../vidfleet/views/sdCardStatus";
import TroubleShootingEvents from '../troubleShootingEventsTab';
import VidFleetMenu from 'Modules/vidfleet/views/.components/menu';
import UserTroubleshooting from 'Modules/devices/.components/userTroubleshooting';
import MaintenanceWarningEvents from 'Modules/maintenanceWarningEvents/views/main';
const TabVidFleetTroubleshooting = (props) => {

    const [module, setModule] = useState(0);

    const renderModule = {
        0: (
            <TroubleShootingEvents
                single
                device={props.device}
                height={props.height}
                className="range-date-modal"
                module={module}
                setModule={setModule}
                timezone={props.timezone}
                fromVidFleet={true}
            />
        ),
        1: (
            <UserTroubleshooting
                single
                device={props.device}
                height={props.height}
                className="range-date-modal"
                module={module}
                setModule={setModule}
                timezone={props.timezone}
                companyName={props.companyName}
            />
        ),
        2: (
            <MaintenanceWarningEvents
                tabMode
                device={props.device}
                module={module}
                setModule={setModule}
                height={props.height}
                timezone={props.timezone}
            />
        ),
        3: (
            <CameraLogs
                single
                device={props.device}
                module={module}
                setModule={setModule}
                height={props.height}
                timezone={props.timezone}
            />
        ),
        4: (
            <DmsStatuses
                single
                device={props.device}
                module={module}
                setModule={setModule}
                height={props.height}
                timezone={props.timezone}
            />
        ),
        5: (
            <PowerLost
                single
                device={props.device}
                module={module}
                setModule={setModule}
                height={props.height}
                timezone={props.timezone}
            />
        ),
        6: (
            <SdCardStatus
                single
                device={props.device}
                module={module}
                setModule={setModule}
                timezone={props.timezone}
            />
        )
    }

    return (
        <Fragment>
            <div>
                <VidFleetMenu setModule={setModule} module={module} />
            </div>
            {renderModule[module]}
        </Fragment>
    );
};

export default TabVidFleetTroubleshooting;